import { Link, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

function trackingLink(tracking_id) {
    let link_target = tracking_id.length === 26 ? `https://tools.usps.com/go/TrackConfirmAction?tLabels=${tracking_id}` : `http://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=${tracking_id}`;
    return <Link target="_blank" style={{textDecoration: "none"}} href={link_target}>{tracking_id}</Link>;
}


const TrackingInfoCard = ({object}) => {
    return <Stack sx={{margin: 2}} spacing={2} direction={"row"}>
        <Typography variant="p">Tracking number: {trackingLink(object.tracking_id)} - last updated {dayjs.utc(object.updated).local().format("YYYY-DD-MM")}</Typography>
        </Stack>;
}

export { TrackingInfoCard };